var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/CountryBottomSheetModal/index.tsx";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { BottomSheet } from '@adc/parallax-component-library';
import { Divider, RadioListItem, Stack } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
const mapStateToProps = ({
  scrollPage: {
    mainSize
  }
}) => {
  return {
    mainSize
  };
};
const connector = connect(mapStateToProps);
const CountryBottomSheetModal = ({
  isOpen,
  onCancel,
  onDone,
  mainSize,
  selectedCountry,
  title,
  countries
}) => {
  const [selectedItem, setSelectedItem] = useState(selectedCountry);
  const ref = useRef(null);
  const orderedCountryList = useMemo(() => {
    return countries.filter(country => i18n.exists(`Global.microcopy.countries.${country.toUpperCase()}`)).map(country => ({
      code: country.toUpperCase(),
      name: i18n.t(`Global.microcopy.countries.${country.toUpperCase()}`)
    })).sort((a, b) => a.name.localeCompare(b.name));
  }, [countries]);
  useEffect(() => {
    if (isOpen) {
      ref.current?.present();
    } else {
      ref.current?.close();
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(BottomSheet, {
    enableDynamicSizing: true,
    ref: ref,
    onDismiss: onCancel,
    onBackdropClick: () => {
      if (selectedItem) {
        onDone(selectedItem);
      } else {
        onCancel?.();
      }
    },
    topNavigationProps: {
      title,
      buttonStart: {
        element: i18n.t('Global.microcopy.common.cancel'),
        onPress: () => {
          setSelectedItem(selectedCountry);
          onCancel?.();
        },
        label: i18n.t('Global.microcopy.common.cancel')
      },
      buttonEnd: {
        element: i18n.t('Global.microcopy.common.done'),
        onPress: () => {
          if (selectedItem) {
            onDone(selectedItem);
          } else {
            onCancel?.();
          }
        },
        label: i18n.t('Global.microcopy.common.done')
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: mainSize / 2
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 7
    }
  }, orderedCountryList.map(({
    code,
    name
  }) => {
    return /*#__PURE__*/React.createElement(Stack, {
      key: code,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(RadioListItem, {
      key: code,
      title: name,
      "aria-label": name,
      disabled: false,
      selected: selectedItem === code,
      onPress: () => setSelectedItem(code),
      testID: `Country.${code}`,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 107,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Divider, {
      marginTop: "$2",
      borderColor: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 116,
        columnNumber: 15
      }
    }));
  })));
};
const ConnectedCountryBottomSheetModal = connector(CountryBottomSheetModal);
export { ConnectedCountryBottomSheetModal as CountryBottomSheetModal };